export default [
    "Accuser",
    "Adamant",
    "Adarga",
    "Admonitor",
    "Adjucator",
    "Adjudicator",
    "Agonizer",
    "Allecto",
    "Assassin",
    "Avarice",
    "Avenger",
    "Basilisk",
    "Bellicose",
    "Chimaera",
    "Colosses",
    "Conqueror",
    "Conquest",
    "Courageous",
    "Crynyd",
    "Devastator",
    "Direption",
    "Emancipator",
    "Engager",
    "Entor",
    "Eviscerator",
    "Executor",
    "Freedom",
    "Firestorm",
    "Gauntlet",
    "Garrett",
    "Glory",
    "Gnisnal",
    "Gorgon",
    "Hammer",
    "Hydra",
    "Inflexible",
    "Intrepid",
    "Immortal",
    "Imperator",
    "Inexorable",
    "Interrogator",
    "Invincible",
    "Judicator",
    "Kreiger",
    "Leonides",
    "Lusankya",
    "Majestic",
    "Malice",
    "Manticore",
    "Monarch",
    "Moonshadow",
    "Nemesis",
    "Nihil",
    "Nitsa",
    "Peremptory",
    "Predator",
    "Pulsar",
    "Punisher",
    "Rage",
    "Reckoning",
    "Redoubtable",
    "Relentless",
    "Reliance",
    "Render",
    "Resolution",
    "Retribution",
    "Reyna",
    "Riesa",
    "Skyhook",
    "Stalker",
    "Steadfast",
    "Stormhawk",
    "Thunderflare",
    "Thunderer",
    "Tiger",
    "Tormentor",
    "Triumph",
    "Tyrant",
    "Ultima",
    "Vanguard",
    "Vendetta",
    "Vengeance",
    "Virulence",
    "Warrior",
    "Whirlwind",
    "Enterprise",
    "Voyager",
    "Defiant",
    "Excelsior",
    "Reliant",
    "Stargazer",
    "Adelphi",
    "Agamemnon",
    "Ahwahnee",
    "Akagi",
    "Antares",
    "Arcos",
    "Ariel",
    "Aries",
    "Artemis",
    "Augyn",
    "Aurora",
    "Beagle",
    "Bellerophon",
    "Billings",
    "Bonchune",
    "Bounty",
    "Bozeman",
    "Brattain",
    "Buran",
    "Carolina",
    "Centaur",
    "Clavin",
    "Concord",
    "Constellation",
    "Constitution",
    "Copernicus",
    "Destiny",
    "Drake",
    "Eagle",
    "Elkins",
    "Endeavour",
    "Equinox",
    "Excalibur",
    "Fearless",
    "Firebrand",
    "Gallico",
    "Gander",
    "Ganges",
    "Greyhound",
    "Grissom",
    "Hathaway",
    "Hatteras",
    "Helin",
    "Hera",
    "Hermes",
    "Hispaniola",
    "Honshu",
    "Hood",
    "Horatio",
    "Horizon",
    "Hornet",
    "Huron",
    "Kearsarge",
    "Kelvin",
    "Kongo",
    "Korolev",
    "Kyushu",
    "Lalo",
    "Lantree",
    "Lexington",
    "Liberator",
    "Livingston",
    "Magellan",
    "Malinche",
    "Mayflower",
    "Mekong",
    "Merrimac",
    "Muleskinner",
    "Nash",
    "Nautilus",
    "Nebula",
    "Noble",
    "Norkova",
    "Northridge",
    "Nova",
    "Oberth",
    "Odin",
    "Odyssey",
    "Orinoco",
    "Pasteur",
    "Potemkin",
    "Prometheus",
    "Proxima",
    "Pueblo",
    "Raven",
    "Renegade",
    "Republic",
    "Repulse",
    "Revere",
    "Rubicon",
    "Rutledge",
    "Saratoga",
    "Scovil",
    "Seaquest",
    "Seaview",
    "Sentinel",
    "Shepard",
    "Shirkahr",
    "Silversides",
    "Sitak",
    "Strata",
    "Syracuse",
    "Thunderchild",
    "Titan",
    "Tombaugh",
    "Trieste",
    "Valiant",
    "Venture",
    "Victory",
    "Volga",
    "Yamato",
    "Yorktown",
    "Aragorn",
    "Arod",
    "Asfaloth",
    "Beren",
    "Bilbo",
    "Boromir",
    "Celeborn",
    "Denethor",
    "Elrond",
    "Elros",
    "Eomer",
    "Eowyn",
    "Faramir",
    "Frodo",
    "Galadriel",
    "Gandalf",
    "Gimli",
    "Gamling",
    "Glorfindel",
    "Grima",
    "Gollum",
    "Hasufel",
    "Legolas",
    "Luthien",
    "Merry",
    "Pippin",
    "Quickbeam",
    "Radagast",
    "Saruman",
    "Sauron",
    "Shadowfax",
    "Theoden",
    "Treebeard",
    "Valandil",
    "Numendil",
    "Aratan",
    "Cemendur",
    "Eldarion",
    "Augustus",
    "Tiberius",
    "Caligula",
    "Claudius",
    "Nero",
    "Galba",
    "Otho",
    "Vitellius",
    "Titus",
    "Domitian",
    "Nerva",
    "Trajan",
    "Hadrian",
    "Antoninus",
    "Marcus",
    "Lucius",
    "Commodus",
    "Pertinax",
    "Didius",
    "Septimius",
    "Caracalla",
    "Geta",
    "Macrinus",
    "Elagabalus",
    "Severus",
    "Maximinus",
    "Gordian",
    "Pupienus",
    "Balbinus",
    "Philip",
    "Hostilian",
    "Trebonianus",
    "Aemilian",
    "Gallienus",
    "Quintillus",
    "Aurelian",
    "Tacitus",
    "Florian",
    "Probus",
    "Carus",
    "Numerian",
    "Carinus",
    "Diocletian",
    "Maximian",
    "Constantius",
    "Galerius",
    "Constantine",
    "Maxentius",
    "Constans",
    "Vetranio",
    "Julian",
    "Jovian",
    "Jimmu",
    "Suizei",
    "Annei",
    "Itoku",
    "Koushou",
    "Kouan",
    "Kourei",
    "Kaika",
    "Sujin",
    "Suinin",
    "Keikou",
    "Seimu",
    "Chuuai",
    "Jinguu",
    "Oojin",
    "Nintoku",
    "Richuu",
    "Hanzei",
    "Ingyou",
    "Ankou",
    "Yuuryaku",
    "Seinei",
    "Kenzou",
    "Ninken",
    "Buretsu",
    "Keitai",
    "Ankan",
    "Senka",
    "Kimmei",
    "Bidatsu",
    "Youmei",
    "Sushun",
    "Suikou",
    "Jomei",
    "Kougyoku",
    "Koutoku",
    "Saimei",
    "Tenji",
    "Koubun",
    "Temmu",
    "Jitou",
    "Mommu",
    "Gemmei",
    "Genshou",
    "Shoumu",
    "Kouken",
    "Junnin",
    "Shoutoku",
    "Kounin",
    "Kammu",
    "Heizei",
    "Saga",
    "Junna",
    "Ninmyou",
    "Montoku",
    "Seiwa",
    "Youzei",
    "Koukou",
    "Uda",
    "Daigo",
    "Suzaku",
    "Murakami",
    "Reizei",
    "En'yu",
    "Kazan",
    "Ichijou",
    "Sanjou",
    "Goichijou",
    "Gosuzaku",
    "Goreizei",
    "Gosanjou",
    "Shirakawa",
    "Horikawa",
    "Toba",
    "Sutoku",
    "Alcatraz",
    "Antigua",
    "Barbados",
    "Bermuda",
    "Cabrera",
    "Cayman",
    "Corsica",
    "Cozumel",
    "Crete",
    "Cuba",
    "Dog",
    "Dragonera",
    "Easter",
    "Eivissa",
    "Elba",
    "Ellis",
    "Formentera",
    "Grenada",
    "Greenland",
    "Hawaii",
    "Kauai",
    "Lanai",
    "Molokai",
    "Maui",
    "Oahu",
    "Hokkaido",
    "Shikoku",
    "Ibiza",
    "Iceland",
    "Ireland",
    "Jamaica",
    "Java",
    "Kangaroo",
    "Krakatoa",
    "Mackinac",
    "Madagascar",
    "Mallorca",
    "Menorca",
    "Malta",
    "Midway",
    "Okinawa",
    "Rikers",
    "Saipan",
    "Sardinia",
    "Sicily",
    "Ceylon",
    "Tasmania",
    "Tortuga",
    "Vancouver",
    "Allosaurus",
    "Apatosaurus",
    "Baryonyx",
    "Brachiosaurus",
    "Brontosaurus",
    "Camarasaurus",
    "Carcharodontosaurus",
    "Carnoraptor",
    "Carnotaurus",
    "Coelophysis",
    "Compsognathus",
    "Corythosaurus",
    "Deinonychus",
    "Diabloceratops",
    "Diplodocus",
    "Dracoraptor",
    "Edmontosaurus",
    "Euoplocephalus",
    "Gallimimus",
    "Gigantosaurus",
    "Giraffatitan",
    "Hypsilophodon",
    "Iguanodon",
    "Indominus",
    "Janenschia",
    "Jobaria",
    "Kentrosaurus",
    "Lesothosaurus",
    "Macrurosaurus",
    "Maiasaura",
    "Mamenchisaurus",
    "Megalosaurus",
    "Minmi",
    "Notoceratops",
    "Ornithomimus",
    "Oviraptor",
    "Pachycephalosaurus",
    "Parasaurolophus",
    "Plateosaurus",
    "Protoceratops",
    "Psittacosaurus",
    "Riojasaurus",
    "Saurolophus",
    "Saurophaganax",
    "Seismosaurus",
    "Spinoraptor",
    "Spinosaurus",
    "Stegosaurus",
    "Stegoceras",
    "Styracosaurus",
    "Triceratops",
    "Troodon",
    "Tyrannosaurus",
    "Tyrannotitan",
    "Vagaceratops",
    "Vastatosaurus",
    "Velociraptor",
    "Wannanosaurus",
    "Xiaosaurus",
    "Yangchuanosaurus",
    "Zigongosaurus",
    "Cyclops",
    "Iceman",
    "Angel",
    "Archangel",
    "Beast",
    "Mimic",
    "Changeling",
    "Polaris",
    "Havok",
    "Petra",
    "Sway",
    "Darwin",
    "Vulcan",
    "Nightcrawler",
    "Wolverine",
    "Banshee",
    "Storm",
    "Sunfire",
    "Colossus",
    "Thunderbird",
    "Sprite",
    "Shadowcat",
    "Lockheed",
    "Rogue",
    "Phoenix",
    "Prestige",
    "Longshot",
    "Psylocke",
    "Dazzler",
    "Forge",
    "Maker",
    "Gambit",
    "Jubilee",
    "Bishop",
    "Revanche",
    "Cannonball",
    "Marrow",
    "Cable",
    "Mirage",
    "Moonstar",
    "Sage",
    "Xorn",
    "Lifeguard",
    "Slipstream",
    "Northstar",
    "Husk",
    "Juggernaut",
    "Mystique",
    "Warpath",
    "Sabretooth",
    "Armor",
    "Hepzibah",
    "Pixie",
    "Karma",
    "Sunspot",
    "Magma",
    "Box",
    "Magik",
    "Sub-Mariner",
    "Domino",
    "Cloak",
    "Dagger",
    "Boom-Boom",
    "Danger",
    "Cypher",
    "Warlock",
    "Hope",
    "Frenzy",
    "Legion",
    "Warbird",
    "Blink",
    "Firestar",
    "Cerebra",
    "Ink",
    "Scout",
    "Pyro",
    "Gentle",
    "Wolfsbane",
    "Sunder",
    "Siryn",
    "Omerta",
    "Wraith",
    "Fantomex",
    "Beak",
    "Longneck",
    "Forearm",
    "Choir",
    "Dust",
    "Elixir",
    "Hellion",
    "Mercury",
    "Rockslide",
    "Surge",
    "Anole",
    "Prodigy",
    "Blindfold",
    "Graymalkin",
    "Cipher",
    "Trance",
    "Onyxx",
    "Match",
    "Transonic",
    "Velocidad",
    "Primal",
    "Zero",
    "Vanisher",
    "Deadpool",
    "Puck",
    "Spiral",
    "Bird-Brain",
    "Firefist",
    "Skids",
    "Rictor",
    "Shatterstar",
    "Doop",
    "Chamber",
    "Mondo",
    "Valerie",
    "Quicksilver",
    "Random",
    "Shard",
    "Fixx",
    "Greystone",
];
